import { MentionData } from '../consts';

export function isFirstRecentsSuggestion(
  suggestions: MentionData[],
  mention: MentionData,
) {
  if (mention.fromRecents !== true) return false;
  const first = suggestions.find((s) => s.fromRecents);
  return first?.id === mention.id;
}
